<template lang="pug">
section
  s-page-title(title='Сайты')
    template(slot='extension')
  v-card
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :pagination='dataFilter'
      @update:pagination='updatePagination'      
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onSiteEdit(props.item)')
          td {{ props.item.id }}
          td
            v-chip(
                :color="props.item.color ? props.item.color : 'gray'"
                :key="props.item.id"
                text-color="white"
                small
              ) 
          td {{ props.item.name }}
          td {{ props.item.url }}
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    headers: [
      {
        text: "#ID",
        align: "left",
        value: "id",
        width: "2%",
        sortable: false
      },
      {
        text: "Цвет",
        align: "center",
        value: "color",
        width: "2%",
        sortable: false
      },
      {
        text: "Название",
        align: "left",
        sortable: false
      },
      {
        text: "URL",
        align: "left",
        value: "url",
        width: "0%",
        sortable: false
      }
    ]
  }),

  async created() {
    this.fetch();
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination);
      this.fetch();
    },
    async fetch() {
      try {
        await this.fetchList();
      } catch (e) {
        this.$root.showSnack("Ошибка загрузки списка сайтов");
      }
    },

    onSiteAdd() {
      this.$router.push({ name: "Content.Sites.Edit" });
    },

    onSiteEdit({ id }) {
      this.$router.push({
        name: "Content.Sites.Edit",
        params: { id }
      });
    },

    ...mapActions("content/sites", ["fetchList", "destroy"]),
    ...mapMutations("content/sites", ["setDataFilter"])
  },

  computed: {
    ...mapState("content/sites", ["total", "dataFilter"]),
    ...mapGetters("content/sites", ["isLoading", "list"])
  }
};
</script>
